/**
 * Converts a color in various formats (rgb, rgba, hex) to rgba format
 * @param {string} color - Color in rgb, rgba, or hex format
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} RGBA color string (rgba(r, g, b, a))
 */
export const colorToRgba = (color, opacity = 1) => {
  // Ensure opacity is between 0 and 1
  opacity = Math.max(0, Math.min(1, opacity))
    
  // Remove whitespace and convert to lowercase
  const normalizedColor = color.trim().toLowerCase()
    
  // Handle hex colors
  if (normalizedColor.startsWith("#")) {
    const hex = normalizedColor.slice(1)
        
    let r, g, b
        
    // Handle 3-digit hex (#RGB)
    if (hex.length === 3) {
      r = parseInt(hex[0] + hex[0], 16)
      g = parseInt(hex[1] + hex[1], 16)
      b = parseInt(hex[2] + hex[2], 16)
    }
    // Handle 6-digit hex (#RRGGBB)
    else if (hex.length === 6) {
      r = parseInt(hex.slice(0, 2), 16)
      g = parseInt(hex.slice(2, 4), 16)
      b = parseInt(hex.slice(4, 6), 16)
    }
    // Handle 8-digit hex (#RRGGBBAA) - ignore existing alpha and use provided opacity
    else if (hex.length === 8) {
      r = parseInt(hex.slice(0, 2), 16)
      g = parseInt(hex.slice(2, 4), 16)
      b = parseInt(hex.slice(4, 6), 16)
    }
    else {
      throw new Error(`Invalid hex color format: ${color}`)
    }
        
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }
    
  // Handle rgb and rgba colors
  const rgbMatch = normalizedColor.match(/rgba?\(([^)]+)\)/)
  if (rgbMatch) {
    const values = rgbMatch[1].split(",").map(v => v.trim())
        
    if (values.length < 3 || values.length > 4) {
      throw new Error(`Invalid rgb/rgba color format: ${color}`)
    }
        
    const r = parseInt(values[0], 10)
    const g = parseInt(values[1], 10)
    const b = parseInt(values[2], 10)
        
    // Validate RGB values
    if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
      throw new Error(`Invalid RGB values: ${color}`)
    }
        
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }
    
  throw new Error(`Unsupported color format: ${color}`)
} 